import { ref, computed } from "vue";
import { u as useI18n } from "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import { u as useHeightProps } from "./assets/index-BWUsUM8p.js";
import { X as XDropdown, u as usePlacementProp } from "./assets/XDropdown-Bc_0Fycm.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import XListItem from "./XListItem.js";
import XCard from "./XCard.js";
import XBadge from "./XBadge.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/index-4vIud5LZ.js";
import "@floating-ui/dom";
import "./assets/index-Ca8wHgNc.js";
import "./assets/XIcon-U9bwokTN.js";
import "@fortawesome/vue-fontawesome";
import "./assets/BaseLink-KuovKwoP.js";
import "./assets/SingleInput-CdYfqMCu.js";
import "./assets/index-Df_FM1j-.js";
import "./assets/index-BJV0_gaH.js";
import "./XCheckbox.js";
import "./BaseOption.js";
import "./XFormField.js";
import "./assets/SingleMessage-Dv2wNb7f.js";
import "./XLink.js";
import "./XTooltip.js";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
import "./MessagesContainer.js";
import "./MultipleInputs.js";
import "./XEllipsis.js";
import "./assets/index-hC42R8vZ.js";
const XDropdownMenu$1 = "_XDropdownMenu_16lpo_1";
const dropdown = "_dropdown_16lpo_6";
const dropdownContainer = "_dropdownContainer_16lpo_11";
const style0 = {
  XDropdownMenu: XDropdownMenu$1,
  dropdown,
  dropdownContainer
};
const { createDisabledProp } = useDisabledProp();
const { createPlacementProp } = usePlacementProp();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const { createHeightProps, getHeightStyles } = useHeightProps();
const { t } = useI18n();
const __default__ = {
  name: "XDropdownMenu",
  components: {
    XDropdown,
    XListItem,
    XCard,
    XBadge
  }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    options: {
      required: true,
      type: Array,
      default: () => []
    },
    minWidth: {
      type: String,
      default: ""
    },
    innerDropdown: {
      type: Boolean,
      default: false
    },
    newBadgeText: {
      type: String,
      default: () => t("ds.global.badge.new")
    },
    betaBadgeText: {
      type: String,
      default: () => t("ds.global.badge.beta")
    },
    ...createHeightProps(),
    ...createPlacementProp(),
    ...createDisabledProp(),
    ...createTestIdProp()
  },
  emits: ["selected-item", "focus", "blur"],
  setup(__props, { emit }) {
    const props = __props;
    const { formatTestId } = setupTestId(props);
    const { heightStyles } = getHeightStyles(props);
    const activatorRef = ref(null);
    const activatorWidth = ref();
    const dropdownStyle = computed(() => {
      return {
        minWidth: props.minWidth || activatorWidth.value,
        ...heightStyles.value
      };
    });
    function handleAction(item) {
      if (item.action) item.action(item);
      emit("selected-item", item);
    }
    function handleActivator(on) {
      var _a;
      activatorWidth.value = `${(_a = activatorRef.value) == null ? void 0 : _a.offsetWidth}px`;
      return on;
    }
    function getItemTagName(item) {
      if (item.href) return "a";
      if (item.isTitle) return "div";
      return "button";
    }
    function getBadgeIcon(item) {
      if (item.isNew) {
        return "sparkles";
      }
      return "gem";
    }
    function getBadgeText(item) {
      if (item.isNew) {
        return props.newBadgeText;
      }
      return props.betaBadgeText;
    }
    return { __sfc: true, createDisabledProp, createPlacementProp, createTestIdProp, setupTestId, createHeightProps, getHeightStyles, t, props, emit, formatTestId, heightStyles, activatorRef, activatorWidth, dropdownStyle, handleAction, handleActivator, getItemTagName, getBadgeIcon, getBadgeText, XDropdown, XListItem, XCard, XBadge };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.XDropdown, { class: _vm.$style.XDropdownMenu, attrs: { "placement": _vm.placement, "inner-dropdown": _vm.innerDropdown, "data-testid": _vm.dataTestid, "disabled": _vm.disabled }, on: { "focus": function($event) {
    return _vm.$emit("focus");
  }, "blur": function($event) {
    return _vm.$emit("blur");
  } }, scopedSlots: _vm._u([{ key: "activator", fn: function({ on }) {
    return [_c("div", { ref: "activatorRef" }, [_vm._t("activator", null, { "on": _setup.handleActivator(on) })], 2)];
  } }], null, true) }, [_c(_setup.XCard, { class: _vm.$style.dropdown, style: _setup.dropdownStyle, attrs: { "elevation": "medium", "padding": "0px", "data-testid": _setup.formatTestId("card") } }, [_c("div", { class: _vm.$style.dropdownContainer }, [_vm._l(_vm.options, function(item, index) {
    return [_vm._t(`slot-${item.slot}`, function() {
      return [!item.slot ? [_c(_setup.XListItem, { key: `${index}-item`, attrs: { "tag": _setup.getItemTagName(item), "separator": item.isTitle, "to": item.href, "target": item.target, "icon": item.icon, "icon-style": item.iconStyle, "data-testid": item.dataTestId, "disabled": item.disabled, "navigable": true }, on: { "click": function($event) {
        return _setup.handleAction(item);
      } }, scopedSlots: _vm._u([item.isNew || item.isBeta ? { key: "badge", fn: function({ badgeClass }) {
        return [_c(_setup.XBadge, { class: badgeClass, attrs: { "icon": _setup.getBadgeIcon(item), "color": "brand-primary", "size": "sm" } }, [_vm._v(" " + _vm._s(_setup.getBadgeText(item)) + " ")])];
      } } : null], null, true) }, [_vm._v(" " + _vm._s(item.text) + " ")])] : _vm._e()];
    }, { "item": item })];
  })], 2)])], 1);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XDropdownMenu = __component__.exports;
export {
  XDropdownMenu as default
};
